import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ReforgeProvider } from '@reforge-com/react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { REFORGE_FRONTEND_SDK_KEY as reforgeSdkKey } from '../Constants';
/**
 * Wrapper for ReforgeProvider that provides contextAttributes based on the current admin.
 * This allows Reforge feature flags to be segmented by user attributes.
 *
 * Only initializes ReforgeProvider after the user is authenticated, since feature flags
 * require user context and aren't needed on the login page.
 *
 * @see https://docs.prefab.cloud/docs/sdks/react#using-context
 */
export default function ReforgeProviderWrapper({ children }) {
    const currentAdmin = useSelector((state) => state.admins.current_admin);
    const contextAttributes = useMemo(() => {
        if (!currentAdmin?.id) {
            return null;
        }
        return {
            user: {
                key: String(currentAdmin.id),
                email: currentAdmin.email,
                name: currentAdmin.name
            },
            admin: {
                key: String(currentAdmin.id),
                logged_in_as: currentAdmin.logged_in_as,
                is_super_admin: String(currentAdmin.is_super_admin),
                is_client_admin: String(currentAdmin.is_client_admin ?? false),
                client_id: currentAdmin.client_id ? String(currentAdmin.client_id) : undefined
            }
        };
    }, [
        currentAdmin?.id,
        currentAdmin?.email,
        currentAdmin?.name,
        currentAdmin?.logged_in_as,
        currentAdmin?.is_super_admin,
        currentAdmin?.is_client_admin,
        currentAdmin?.client_id
    ]);
    // Don't initialize Reforge until user is authenticated - feature flags
    // require user context and aren't needed on the login page
    if (!contextAttributes) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(ReforgeProvider, { sdkKey: reforgeSdkKey, contextAttributes: contextAttributes, onError: reason => console.error('Reforge error:', reason), children: children }));
}
